import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import CustomizedSnackbars from "../../components/alert/Alert";
import api from "../../services/api";
import perto2 from "../../images/perto2.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Box, createTheme, Grid, styled, ThemeProvider } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

let text = "";
let tipo = "";

export default function Cadastro({ location, validarSessao }) {
  const [alerta, setAlerta] = useState(false);
  const [comboFuncoes, setComboFuncoes] = useState([]);
  const [formulario, setFormulario] = useState({
    nome: "",
    CPF: "",
    senha: "",
    repeticaoSenha: "",
    email: "",
    aceiteTelefone: true,
    funcaoId: 0,
    chaveAcesso: "",
  });
  const history = useHistory();

  useEffect(() => {
    carregarComboFuncoes();
  }, []);

  const carregarComboFuncoes = () => {
    api
      .get("funcoes/listar", { ativas: true })
      .then((res) => {
        const comboFuncoes = [];

        comboFuncoes.push({ value: 0, desc: "(Função)" });

        setComboFuncoes(res);
      })
      .catch(() =>
        alert("Você está offline. Verifique sua conexão e tente novamente.")
      );
  };

  const cadastrar = (e) => {
    e.preventDefault();

    if (!validar(formulario)) return;

    api
      .put("profissionais/inserirViaApp", formulario)
      .then((res) => {
        text =
          "Efetue o login para configurar seu acesso começar a utilizar o aplicativo.";
        tipo = "success";
        alertMsg();
        return history.goBack();
      })
      .catch((err) => {
        const codes = err.data;
        if (!codes || !codes.length) {
          text =
            "Não foi possível enviar os dados para o servidor. Verifique os dados informados e sua conexão e tente novamente.";
          tipo = "error";
          alertMsg();
        } else {
          if (codes.includes(1)) {
            text = "Verifique o nome informado e tente novamente.";
            tipo = "error";
            alertMsg();
          }

          if (codes.includes(2)) {
            text = "Verifique o CPF informado e tente novamente.";
            tipo = "error";
            alertMsg();
          }

          if (codes.includes(3)) {
            text = "Verifique o email informado e tente novamente.";
            tipo = "error";
            alertMsg();
          }

          if (codes.includes(4)) {
            text = "Verifique a senha informada e tente novamente.";
            tipo = "error";
            alertMsg();
          }

          if (codes.includes(5)) {
            text = "Verifique a chave de acesso e tente novamente.";
            tipo = "error";
            alertMsg();
          }

          if (codes.includes(6)) {
            text = "Verifique a função selecionada e tente novamente.";
            tipo = "error";
            alertMsg();
          }

          if (codes.includes(7)) {
            text =
              "Já existe uma conta cadastrada na Perto com o CPF informado. Se necessário, utilize a opção de recuperação de senha.";
            tipo = "error";
            alertMsg();
          }
        }
      });
  };

  const preencher = (campo, valor) => {
    const formularioAtualizado = { ...formulario };

    formularioAtualizado[campo] = valor;
    setFormulario(formularioAtualizado);
  };

  const validar = (formulario) => {
    let isOk = true;
    if (formulario.nome === "") {
      isOk = false;

      text = "Informe o nome";
      tipo = "warning";
      alertMsg();
    }

    if (formulario.CPF === "") {
      isOk = false;

      text = "Informe o CPF";
      tipo = "warning";
      alertMsg();
    }

    if (formulario.senha === "") {
      isOk = false;

      text = "Informe a senha";
      tipo = "warning";
      alertMsg();
    } else {
      if (formulario.senha !== formulario.repetirSenha) {
        isOk = false;

        text = "A senha informada é diferente da confirmação.";
        tipo = "warning";
        alertMsg();
      }
    }

    if (formulario.email === "") {
      isOk = false;

      text = "Informe seu email";
      tipo = "warning";
      alertMsg();
    }

    if (formulario.funcaoId === 0) {
      isOk = false;

      text = "Selecione sua função";
      tipo = "warning";
      alertMsg();
    }

    if (formulario.funcaoId === 0) {
      isOk = false;

      text = "Informe a chave de acesso";
      tipo = "warning";
      alertMsg();
    }

    return isOk;
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <Box height={window.innerHeight} style={{ background: "#3d79bd" }}>
      <Grid container style={{ background: "#3d79bd" }}>
        <Grid container direction="row" justifyContent="center">
          <Grid
            item
            xs={12}
            style={{
              paddingLeft: 15,
            }}
          >
            <h4
              style={{
                textDecoration: "none",
                color: "white",
                fontSize: "1.5rem",
              }}
            >
              <ArrowBackIcon
                onClick={() => history.push("login")}
                style={{
                  fontWeight: "bolder",
                  color: "white",
                  marginRight: 20,
                  cursor: "pointer",
                }}
              />
              Meu cadastro
            </h4>
          </Grid>
          <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
            <img src={perto2} width={"50%"} alt="" />
            <h4
              style={{
                textDecoration: "none",
                color: "white",
                fontSize: "1.5rem",
              }}
            >
              Dados pessoais
            </h4>
          </Grid>
          <form onSubmit={cadastrar}>
            <Grid
              container
              item
              xs={12}
              style={{
                textAlign: "center",
                padding: !isMobile ? "0px 30% 0px 30%" : 10,
              }}
            >
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  id="nome"
                  label="Nome completo"
                  variant="filled"
                  type="text"
                  fullWidth
                  onChange={(event) => preencher("nome", event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="CPF"
                  label="CPF"
                  variant="filled"
                  type="number"
                  pattern="[0-9]+"
                  onChange={(event) => preencher("CPF", event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="email"
                  label="Email"
                  variant="filled"
                  type="text"
                  onChange={(event) => preencher("email", event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="senha"
                  label="Senha"
                  variant="filled"
                  type="password"
                  onChange={(event) => preencher("senha", event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="repetirSenha"
                  label="Repetir senha"
                  variant="filled"
                  type="password"
                  onChange={(event) =>
                    preencher("repetirSenha", event.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="chave"
                  label="Chave de acesso"
                  variant="filled"
                  type="text"
                  onChange={(event) =>
                    preencher("chaveAcesso", event.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  style={{
                    marginTop: "10px",
                    background: "#FFFF",
                    borderRadius: 10,
                  }}
                  fullWidth
                  id="funcao"
                  select
                  label="Função"
                >
                  {comboFuncoes.map((option) => (
                    <MenuItem
                      onClick={(event) => preencher("funcaoId", option.id)}
                      key={option.value}
                      value={option.id}
                    >
                      {option.nome}
                    </MenuItem>
                  ))}
                </FormTextField>
              </Grid>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <ThemeProvider theme={theme}>
                  <Button
                    fullWidth
                    style={{
                      color: "white",
                      marginTop: "10px",
                      marginBottom: "10px",
                      fontWeight: "bold",
                      width: "50%",
                      fontFamily: "Gilroy-ExtraBold",
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Salvar
                  </Button>
                </ThemeProvider>
              </Grid>
            </Grid>
          </form>
          {alerta && (
            <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
          )}
        </Grid>
      </Grid>
    </Box>
    // <Container>
    //   <Box1>
    //     <BoxForm
    //       style={{
    //         width: isMobile ? "100%" : "450px",
    //       }}
    //     >
    //       <Form onSubmit={cadastrar}>
    //         <BoxImg>
    //           <img src={logo} alt="logo" />
    //           <h4>Cadastro</h4>
    //         </BoxImg>
    //         <Stack spacing={1} sx={{ width: "100%" }}>
    //           {msgAlerta && (
    //             <div style={{ padding: 5, backgroundColor: "orange" }}>
    //               <h5>{msgAlerta}</h5>
    //             </div>
    //           )}
    //           <TextField
    //             style={{
    //               margin: "30px",
    //               background: "#FFFF",
    //               // WebkitAppearance: 'none',
    //             }}
    //             id="nome"
    //             label="Nome completo"
    //             variant="filled"
    //             type="text"
    //             // pattern="[0-9]+"
    //             onChange={(event) => preencher("nome", event.target.value)}
    //           />
    //           <TextField
    //             style={{
    //               margin: "30px",
    //               background: "#FFFF",
    //               // WebkitAppearance: 'none',
    //             }}
    //             id="CPF"
    //             label="CPF"
    //             variant="filled"
    //             type="number"
    //             pattern="[0-9]+"
    //             onChange={(event) => preencher("cpf", event.target.value)}
    //           />

    //           <TextField
    //             style={{
    //               margin: "30px",
    //               background: "#FFFF",
    //               // WebkitAppearance: 'none',
    //             }}
    //             id="email"
    //             label="Email"
    //             variant="filled"
    //             type="text"
    //             // pattern="[0-9]+"
    //             onChange={(event) => preencher("email", event.target.value)}
    //           />

    //           <TextField
    //             style={{ margin: "30px", background: "#FFFF" }}
    //             id="senha"
    //             label="Senha"
    //             variant="filled"
    //             type="password"
    //             onChange={(event) => preencher("senha", event.target.value)}
    //           />
    //           <TextField
    //             style={{ margin: "30px", background: "#FFFF" }}
    //             id="repetirSenha"
    //             label="Repetir senha"
    //             variant="filled"
    //             type="password"
    //             onChange={(event) =>
    //               preencher("repetirSenha", event.target.value)
    //             }
    //           />

    //           <TextField
    //             style={{ margin: "30px", background: "#FFFF" }}
    //             id="chave"
    //             label="Chave de acesso"
    //             variant="filled"
    //             type="text"
    //             onChange={(event) => preencher("chave", event.target.value)}
    //           />

    //           <TextField
    //             style={{ margin: "30px", background: "#FFFF" }}
    //             id="funcao"
    //             select
    //             label="Função"
    //           >
    //             {comboFuncoes.map((option) => (
    //               <MenuItem
    //                 onClick={(event) => preencher("funcaoId", option.value)}
    //                 key={option.value}
    //                 value={option.value}
    //               >
    //                 {option.desc}
    //               </MenuItem>
    //             ))}
    //           </TextField>

    //           <ThemeProvider theme={theme}>
    //             <Button
    //               style={{ margin: "20px", color: "white", fontWeight: "bold" }}
    //               type="submit"
    //               variant="contained"
    //             >
    //               Continuar
    //             </Button>
    //           </ThemeProvider>

    //           <ThemeProvider theme={secondary}>
    //             <Button
    //               style={{ margin: "20px", color: "white", fontWeight: "bold" }}
    //               variant="contained"
    //               target="_blank"
    //               onClick={() => history.push("/login")}
    //             >
    //               Voltar
    //             </Button>
    //           </ThemeProvider>
    //         </Stack>
    //         {alerta && (
    //           <CustomizedSnackbars
    //             texto={text}
    //             tipo={tipo}
    //           ></CustomizedSnackbars>
    //         )}
    //       </Form>
    //     </BoxForm>
    //   </Box1>
    // </Container>
  );
}

const FormTextField = styled((props) => (
  <TextField
    InputProps={{
      style: {
        fontWeight: "bolder",
      },
      disableUnderline: true,
    }}
    InputLabelProps={{
      style: { color: "black", fontFamily: "Gilroy-ExtraBold" },
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    borderRadius: 10,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#eaeaea",
    },
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      main: "#F5B01B",
    },
  },
});

const secondary = createTheme({
  palette: {
    primary: {
      main: "#00b0ef",
    },
  },
});

const third = createTheme({
  palette: {
    primary: {
      main: "#929699",
    },
  },
});
